var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":_vm.toggleMenu}},[_c('span',{staticClass:"fa-stack fa-2x"},[_c('i',{staticClass:"far fa-circle fa-stack-2x "}),_c('i',{class:_vm.faClasses})])])}
var staticRenderFns = []

export { render, staticRenderFns }